import { render, staticRenderFns } from "./ArticleThree.vue?vue&type=template&id=1304944c&scoped=true"
import script from "./ArticleThree.vue?vue&type=script&lang=js"
export * from "./ArticleThree.vue?vue&type=script&lang=js"
import style0 from "./ArticleThree.vue?vue&type=style&index=0&id=1304944c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1304944c",
  null
  
)

export default component.exports